module.exports = __webpack_public_path__ + "img/icon-docs.ae92cba7.svg";